import { supabase } from './supabase'

/**
 * Avis (cloche) : créés par la base (déclencheurs et rappels de 5 h), lus
 * ici. Une copie est gardée sur l'appareil pour l'affichage hors ligne.
 */
export interface Avis {
  id: string
  type: 'assigne' | 'a_valider' | 'rejetee' | 'echeance_demain' | 'en_retard' | 'qrt_sans_reponse'
  suivi_id: string | null
  chantier_id: string | null
  titre: string
  texte: string | null
  cree_le: string
  lu_le: string | null
}

const CLE = 'chantiers-larente:avis'
const auditeurs = new Set<(a: Avis[]) => void>()
let dernier: Avis[] = lireCopie()

function lireCopie(): Avis[] {
  try {
    return JSON.parse(localStorage.getItem(CLE) ?? '[]')
  } catch {
    return []
  }
}

function publier(a: Avis[]) {
  dernier = a
  try {
    localStorage.setItem(CLE, JSON.stringify(a))
  } catch {
    /* stockage indisponible */
  }
  auditeurs.forEach((f) => f(a))
}

export function surAvis(f: (a: Avis[]) => void): () => void {
  auditeurs.add(f)
  f(dernier)
  return () => auditeurs.delete(f)
}

/** Les 60 derniers avis de l'utilisateur connecté. */
export async function rafraichirAvis(): Promise<Avis[]> {
  if (!navigator.onLine) return dernier
  const { data, error } = await supabase
    .from('avis')
    .select('id, type, suivi_id, chantier_id, titre, texte, cree_le, lu_le')
    .order('cree_le', { ascending: false })
    .limit(60)
  if (error) return dernier
  publier((data ?? []) as Avis[])
  return dernier
}

export async function marquerLus(ids: string[]): Promise<void> {
  if (ids.length === 0) return
  const maintenant = new Date().toISOString()
  publier(dernier.map((a) => (ids.includes(a.id) ? { ...a, lu_le: a.lu_le ?? maintenant } : a)))
  if (!navigator.onLine) return
  await supabase.from('avis').update({ lu_le: maintenant }).in('id', ids).is('lu_le', null)
}

/** Vide la copie locale (déconnexion : un autre compte peut se connecter sur l'appareil). */
export function oublierAvis() {
  publier([])
}

export const ICONE_AVIS: Record<Avis['type'], string> = {
  assigne: '→',
  a_valider: '✓',
  rejetee: '↺',
  echeance_demain: '⏱',
  en_retard: '!',
  qrt_sans_reponse: '?'
}
